export const MEDIA_SIZE_XS = "(max-width: 575px)";
export const MEDIA_SIZE_SM = "(max-width: 767px)";
export const MEDIA_SIZE_MD = "(max-width: 991px)";
